import { Workspace } from "models/workspace";

/**
 * If the dashboard being removed/deleted is the active one, switch to the next available dashboard.
 * Returns the new activeDashboardId if switched, otherwise undefined.
 */
export function switchActiveDashboardIfNeeded(
  workspace: Workspace | undefined,
  activeDashboardId: string | undefined,
  removedDashboardId: string,
  workspaceDispatch: (action: { payload: { activeDashboardId: string } }) => void
): string | undefined {
  if (!workspace || !activeDashboardId) return undefined;

  if (activeDashboardId === removedDashboardId) {
    const dashboards = workspace.dashboards || [];
    const firstDashboard = dashboards.find((d) => d.dashboardId !== removedDashboardId);

    if (firstDashboard) {
      workspaceDispatch({ payload: { activeDashboardId: firstDashboard.dashboardId } });
      return firstDashboard.dashboardId;
    }
  }
  return undefined;
}
